import script from "./ChangeCo.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeCo.vue?vue&type=script&setup=true&lang=js"

import "./ChangeCo.vue?vue&type=style&index=0&id=46abb6cb&lang=less&scoped=true"

import exportComponent from "D:\\aj项目\\code\\清洁能源\\氢能会议系统\\chic-conference\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46abb6cb"]])

export default __exports__